<template>
  <v-btn
    :disabled="disabled"
    :loading="loading"
    color="primary"
    class="custom-button"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
}
</script>

<style scoped>
.custom-button {
  text-transform: none;
  font-weight: 500;
  height: 45px !important;
  border-radius: 8px !important;
}
</style>